<template>
    <div class="study">
        <el-tooltip class="item" content="上一页" effect="light" placement="bottom">
            <img @click="backs()"
                style="float: left; margin: 8px; cursor: pointer; position: absolute; width: 26px; top: 10px; right: 87px; color: #fff;"
                src="../../static/img/fh.png" alt=""
            />
        </el-tooltip>

        <el-tooltip class="item" content="首页" effect="light" placement="bottom">
            <img src="../../static/img/sy.png" @click="back()"
                style="float: left; margin: 8px; cursor: pointer; position: absolute; width: 28px; top: 9px; right: 37px; color: #fff;" alt=""
            />
        </el-tooltip>


        <div class="bbp" style="padding: 20px">
            <div class="price-nav">
                <div class="response-container">
                    <div class="list-box">
                        <ul id="price-nav-list" class="price-nav-list">
                            <li class="price-nav-item current" v-bind:class="{ checked: activeName == '1' }" @click="activeName = '1', getdata()" v-show="userGernre === 1 || userGernre === 0">
                                <p class="price-nav-til">个人</p>
                                <div class="current-bg visibile-xs"></div>
                            </li>
                            <li class="price-nav-item" v-bind:class="{ checked: activeName == '2' }" @click="activeName = '2', getdata()" v-show="userGernre === 2 || userGernre === 0">
                                <p class="price-nav-til">单位</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="hr"></div>
            </div>

            <div>
                <p class="p1">{{ VersionInfo.desc }}</p>
                <div style="display: flex; margin-top: 20px;justify-content: center;">
                    <div class="left1">
                        <div style="height: 360px;">
                            <h2 style="color: #fff; margin: 0 auto !important; padding-top: 275px;">功能对比</h2>
                        </div>
                        <template v-for="item, index in VersionInfo.funcList">
                            <p :key="index * 10 + 1" v-if="item == '基础模式'" title="基础识别算法，检测速度快" class="pp">{{ item }}</p>
                            <p :key="index * 10 + 2" v-else-if="item == '增强模式'" title="综合识别算法，判定范围更广" class="pp">{{ item }}</p>
                            <p :key="index * 10 + 3" v-else-if="item == '智能识别模式'" title="检测范围更广，支持疑似判定，检测时间稍长" class="pp">{{ item }}</p>
                            <p :key="index" v-else class="pp">{{ item }}</p>
                        </template>
                        <!-- <p v-for="item,index in VersionInfo.funcList" class="pp" :key="index">{{ item }}</p> -->
                    </div>
                    <div class="left2" v-for="(item, baseIdx) in VersionInfo.BaseInfo" :key="baseIdx">
                        <div style="height: 360px; border-bottom: 1px solid #ccc;">
                            <h2 style="margin: 0 auto !important;">{{ item.version }}</h2>
                            <!-- <p class="desc" v-html="item.desc"></p> -->
                            <p class="price-txt">
                                <span class="price-unim">￥</span>
                                <span class="price-num">{{ item.month.price }}</span>
                                <span class="price-flag">元/月（含{{ item.month.num }}次，{{ item.month.word }}万字）</span><br />
                            </p>
                            <p class="price-7day">
                                <template v-if="item.week">
                                    ￥{{ item.week.price }}元/7天（含{{ item.week.num }}次，{{ item.week.word }}万字）
                                </template>
                                <template v-else>&nbsp;</template>
                            </p>
                            <button type="button" @click="goBuyPage(item)" class="oui-button radius">购买</button>
                        </div>
                        <p class="pp">限制检测{{ item.docWordLimit }}字以内的文章</p>
                        <p class="pp" v-for="(limitVal, idx) in item.funcLimit" :key="idx">
                            <template v-if="limitVal instanceof Array && limitVal.length == 2">
                                <i class="el-icon-check" v-if="limitVal[0] === 1"></i>
                                <span style="margin-left: 10px;">{{ limitVal[1] }}</span>
                            </template>
                            <template v-else>
                                <i class="el-icon-check" v-if="limitVal === 1"></i>
                                <span v-if="limitVal === 0"></span>
                            </template>
                        </p>
                    </div>
                </div>
                <p style="margin-top: 10px;">标注： 超过1000字文章，每1000字核定为1次。</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeName: "1",
            list: [],
            currUserLimitNum: 0,     // 当前用户可添加子用户上限

            VersionInfo: {
                desc: '“企业单位专属审核，支持多帐号协同管理”',
                funcList: ['在线检测文章字数', '基础模式', '增强模式', '智能识别模式', '图片文本审核', '导出报告功能', '英文校验', '文档校验'],
                BaseInfo: [
                    {
                        version: '标准版',
                        desc: '文章审核算法强大<br/>审核方式可使用增强模式，精准判定',
                        docWordLimit: 2000,
                        funcLimit: [1, 1, 1, 0, 0, 0, 0, 0 ]
                    },
                    {
                        version: '高级版',
                        desc: '审核字数不限，精准判定<br/>可调用API审核接口，可导出审核报告',
                        docWordLimit: 5000,
                        funcLimit: [1, 1, 1, 1, 1, 0, 0, 0 ]
                    },
                    {
                        version: 'VIP版',
                        desc: '支持疑似错别字判定识别<br/>智能分析，判定范围更广',
                        docWordLimit: 5000,
                        funcLimit: [1, 1, 1, 1, 1, 1, 1, 1 ]
                    }
                ]
            }
        };
    },
    methods: {
        getdata() {
            this.$axios.post("/cmsMateService/login.do?method=achieveProductPrice", {
                genre: this.activeName,
                username: sessionStorage.getItem("username"),
            }).then((res) => {
                this.list = res.data.info;
                this.currUserLimitNum = res.data.population;
                for(var i = 0; i < 3; i++) {    // 遍历三个版本
                    this.VersionInfo.BaseInfo[i] = {}
                    // 每个版本的价格分为：按月、按周、按次、按用户授权，存储在this.list[i].list，对应flag分别为2,4,1,3
                    this.VersionInfo.BaseInfo[i].priceInfo = this.list[i]
                    this.VersionInfo.BaseInfo[i].version = this.list[i].title
                    for(var j = 0; j < this.list[i].list.length; j++) {
                        var tmpPrice = this.list[i].list[j]
                        if(tmpPrice.flag == 1) this.VersionInfo.BaseInfo[i].times = tmpPrice
                        else if(tmpPrice.flag == 2) this.VersionInfo.BaseInfo[i].month = tmpPrice
                        else if(tmpPrice.flag == 3) this.VersionInfo.BaseInfo[i].userAuth = tmpPrice
                        else if(tmpPrice.flag == 4) this.VersionInfo.BaseInfo[i].week = tmpPrice
                    }
                    this.VersionInfo.BaseInfo[i].timesList = []
                    for(var j = 0; j < this.list[i].list.length; j++) {
                        var tmpPrice = this.list[i].list[j]
                        if(tmpPrice.flag == 1) this.VersionInfo.BaseInfo[i].timesList.push(tmpPrice)
                    }
                }
                if(this.activeName == "1") {
                    this.VersionInfo.BaseInfo[0].docWordLimit = 2000
                    this.VersionInfo.BaseInfo[1].docWordLimit = 4000
                    this.VersionInfo.BaseInfo[2].docWordLimit = 5000
                    // 个人
                    this.VersionInfo.desc = '“ 升级服务，享更稳、更快的审核体验 ”'
                    this.VersionInfo.funcList = ['在线检测文章字数', '基础模式', '增强模式', '智能识别模式', '导出报告功能', '图片文本审核', '英文校验', '文档校验', '图片审核', '视频审核', '网页审核']
                    this.VersionInfo.BaseInfo[0].funcLimit = [1, 1, 1, 0, 0, 0, 0, 0, 0, 0]
                    this.VersionInfo.BaseInfo[1].funcLimit = [1, 1, 1, 1, 0, 1, [1, '1万字'], 0, 0, 0]
                    this.VersionInfo.BaseInfo[2].funcLimit = [1, 1, 1, 1, 1, 1, [1, '20万字'], 1, 1, 1]
                    this.VersionInfo.BaseInfo[0].desc = '文章审核算法强大<br>审核方式可使用增强模式，精准判定'
                    this.VersionInfo.BaseInfo[1].desc = '审核字数不限，精准判定<br>可调用API审核接口，可导出审核报告'
                    this.VersionInfo.BaseInfo[2].desc = '支持疑似错别字判定识别<br>智能分析，判定范围更广'
                } else {
                    this.VersionInfo.BaseInfo[0].docWordLimit = 5000
                    this.VersionInfo.BaseInfo[1].docWordLimit = 10000
                    this.VersionInfo.BaseInfo[2].docWordLimit = 200000
                    // 单位
                    this.VersionInfo.desc = '“ 企业单位专属审核，支持多帐号协同管理 ”'
                    this.VersionInfo.funcList = ['在线检测文章字数', '基础模式', '增强模式', '智能识别模式', '自定义设置', '集团用户', '导出报告功能', '图片文本审核', '调用API接口', '桌面客户端', '英文校验', '文档校验', '图片审核', '视频审核', '网页审核']
                    this.VersionInfo.BaseInfo[0].funcLimit = [1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0]
                    this.VersionInfo.BaseInfo[1].funcLimit = [1, 1, 1, 1, 1, 1, 0, 1, 0, 1, [1, '20万字'], 0, 0, 0]
                    this.VersionInfo.BaseInfo[2].funcLimit = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
                    this.VersionInfo.BaseInfo[0].desc = '文章审核算法强大<br>审核方式可使用增强模式，精准判定'
                    this.VersionInfo.BaseInfo[1].desc = '审核字数不限，精准判定<br>可调用API审核接口，并可以将审核报告导出'
                    this.VersionInfo.BaseInfo[2].desc = '支持疑似错别字判定识别<br>可使用智能模式，智能分析，判定范围更广'
                }
                if (this.isOutService) this.VersionInfo.desc = '本账号服务使用到期，请选择如下的服务'
                console.log('价格基本信息：', this.VersionInfo)
            }).catch((error) => {
                console.log(error.message);
            });
        },
        vip_submin() { this.$router.replace("/Collection"); },
        goBuyPage(item) {
            sessionStorage.setItem('purchaseInfo', window.btoa(encodeURIComponent(JSON.stringify(item))))
            this.$router.push({
                path: "/order",
                query: { type: this.activeName, arr: item, status: item.version, nuns: this.currUserLimitNum },
            });
        },
        backs() { window.history.go(-1); },
        back() { this.$router.push({ path: "/home" }); }
    },
    computed: {
        isOutService () {
            if (parseInt(this.$route.query.from) == 1) return true
            else return false
        },
        userGernre () {
            return parseInt(sessionStorage.getItem('genre'))    // 0-系统 1-个人 2-单位
        }
    },
    mounted() {
        console.log('用户类型：', this.userGernre)
        if (this.userGernre === 1) this.activeName = '1'
        else if (this.userGernre === 2) this.activeName = '2'
        this.getdata();
    },
};
</script>

<style lang="less" scoped>
.stydy {
    background: #f7f7f7;
}

.price-paging {
    max-width: 2560px;
    margin: 0 auto;
    text-align: center;
}

.price-nav .list-box .price-nav-list {
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    overflow: hidden;
    border-bottom: 1px solid #ddd;
    display: flex;
    position: relative;
    justify-content: center;
    text-align: center;
}

.price-nav-item:hover {
    color: rgb(243, 155, 72);
    border-bottom: 2px solid #000;
    cursor: pointer;
}

.checked {
    color: #000;
    border-bottom: 2px solid #606266;
}

.price-nav-item {
    height: 70px;
    float: left;
    width: 171px;
    z-index: 56;
    display: block;
    color: #999;
    position: relative;
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    color: #606266;
}

.p1 {
    opacity: 0.5;
    font-size: 21px;
    font-weight: 400;
    padding: 50px 0;
    text-align: center;
    color: #000;
}

.oui-button {
    width: 180px;
    height: 36px;
    border: 1px solid #fa5928;
    color: #fa5928;
    line-height: 36px;
    margin: 20px 0 0 0;
    background: #fff;
    font-size: 14px;
    border-radius: 4px;
}

.oui-button:hover {
    background: #ff764d;
    color: #fff;
}

.tts {
    border: 1px solid #4d68ff;
    color: #4d68ff;
}

.tts:hover {
    background: #4d68ff;
    color: #fff;
}

.left1 {
    width: 240px;
    background: #1b2327;
    border-radius: 8px 0 0 8px;
    // padding-top: 255px;
    padding-bottom: 55px;
}

.left2:hover {
    background: #fff;
    // border: 5px solid #fff;
}

h2 {
    line-height: 40px;
    padding-top: 31px;
    padding-bottom: 8px;
    font-size: 25px;
    color: #333;
    font-weight: 600;
}

.left2 {
    width: 22.5%;
    border: 1px solid #dcdee2;
    max-width: 395px;
    // padding: 23px 0;
    min-width: 300px;
    background: #f6f7f8;
}

.desc {
    line-height: 22px;
    font-size: 14px;
    color: #6a6a6a;
    padding-bottom: 10px;
}

.price-txt {
    height: 50px;
    padding-bottom: 20px;
    font-size: 14px;
    position: relative;
}
.price-7day {
    color: red;
    min-height: 24px;
}

.price-txt .price-unim {
    font-weight: 600;
}

.price-txt .price-num {
    font-weight: 600;
    font-size: 28px;
}

.price-txt .price-flag {
    color: #666;
}

.add {
    transform: none;
    box-sizing: border-box;
    width: 100%;
    border-bottom: 1px solid #ddd;
    height: 17px;
    position: relative;
    padding: 0 20px;
}
.pp-item {
    display: inline-block;
    text-align: center;
    width: 49%;
}

.left1 .pp {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #fff;
    transition: all 0.4s;
    position: relative;
}

.pp {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: #333;
    transition: all 0.4s;
    position: relative;

    i {
        font-size: 18px;
        font-weight: bold;
    }

    img {
        width: 17px;
    }
}

.pp:hover {
    font-size: 16px;
    color: #ff764d;
    background: #dddddd44;

    i {
        font-size: 25px;
        color: #ff764d;
        -webkit-transition: all 0.4s;
        transition: all 0.4s;
    }
}

.danwei .pp:hover {
    font-size: 16px;
    color: #4d68ff;
    background: #dddddd44;

    i {
        font-size: 25px;
        color: #4d68ff;
        -webkit-transition: all 0.4s;
        transition: all 0.4s;
    }
}

.bbp {
    background: url(https://res.orayimg.com/sunlogin/1.0/img/f99cdad.png) no-repeat;
    background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue